import { useState } from 'react';
import "./Banner.css"
import Button from "./Buttons/Button";

function Banner() {
    const [viewport, setViewport] = useState(document.documentElement.clientWidth);
    window.addEventListener('resize', () => {
        // viewport = document.documentElement.clientWidth;
        setViewport( document.documentElement.clientWidth);
    });
    let bannerClasses = `section banner ${viewport >= 992 ? "desktop" : "mobile"}`;
    let containerClasses = `button-container ${viewport >= 992 ? "desktop" : "mobile"}`;
    let introductionClasses = `introduction ${viewport >= 992 ? "desktop" : "mobile"}`;
    let buttonsClasses = `buttons ${viewport >= 992 ? "desktop" : "mobile"}`;

    return <div id='banner' className={bannerClasses} >
        < div className={containerClasses}>
            <p className={introductionClasses}>Advanced AI and innovative technology enable a cost-effective, fully automated shooting stand system equipped with cloud infrastructure and a mobile app. This solution is designed to assist associations, athletes, coaches, and enthusiasts in mastering the disciplines of shooting sports.</p>
            <div className={buttonsClasses}>
                {/* <Button href = {"/coming-soon-to-the-AppStore"} icon={"./images/store-buttons/bi_apple.svg"} storeName={"App Store"} accompanyingText={"Download on the"} qr={"./images/store-buttons/appstore-qr.svg"} /> */}
                <Button href = {"https://apps.apple.com/am/app/armorx/id6504531791"} icon={"./images/store-buttons/bi_apple.svg"} storeName={"App Store"} accompanyingText={"Download on the"} qr={"./images/store-buttons/appstore-qr.svg"} />
                <Button href = {"https://play.google.com/store/apps/details?id=ai.improvis.armorx"} icon={"./images/store-buttons/mage_playstore.svg"} storeName={"Play Store"} accompanyingText={"Download on the"} qr={"./images/store-buttons/playstore-qr.svg"} />
            </div>
        </div>
    </div>
}

export default Banner;